import React, { useState, useEffect} from 'react';
import { Grid, Typography, Button, Box } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import backgroundImage from '../assets/img/background.jpg';
import useStyles from '../styles/styles';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import {calcEst, showEst, optionsRequired, FONT_FAMILY} from '../common/sharedFunctions';

const Hero = (props) => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const navigate = useNavigate();
  const role = props.role;
  const [loggedIn, setLoggedIn] = useState(false);
  const auth = useSelector(state => state.auth);

  useEffect(()=>{
    if(auth.profile && auth.profile.uid){
      setLoggedIn(true);
    }else{
      setLoggedIn(false);
    }
  },[auth.profile]);

  const handleCtaClick = (e) => {
    e.preventDefault();
    if(loggedIn){
      navigate( ((role && role === 'driver') || (calcEst && !showEst && !optionsRequired && (role === 'admin' || role === 'fleetadmin'))) ? '/bookings' : '/addbookings');
    }else{
      navigate('/login');
    }
  };

  return (
    <Box 
      className={classes.heroBox} 
      sx={{ 
        backgroundImage: `url(${backgroundImage})`,
      }} 
      style={{direction: isRTL === 'rtl'? 'rtl':'ltr'}}
    >
      {/* Floating slogan on upper right */}
      <Box className={classes.floatingSloganBox}>
        <Typography className={classes.floatingSloganWhite}>
          Conectamos<br/>personas,<br/>movemos<br/><span className={classes.floatingSloganPurple}>historias</span>
        </Typography>
      </Box>

      {/* Main hero content container */}
      <Grid container className={classes.gridContainer}>
        <Grid item xs={12} md={7} lg={6} sx={{ overflow: 'visible' }}>
          {/* Subtitle / Kicker */}
          <Box className={classes.heroKicker}>
            <div className={classes.heroKickerLine} />
            <div style={{ lineHeight: 1.4 }}>
              <div>TU DÍA,</div>
              <div>MÁS SIMPLE</div>
            </div>
          </Box>

          {/* Main Title */}
          <Typography component="h1" className={classes.heroTitleWhite}>
            Reserva tu
          </Typography>

          <Box className={classes.heroTitlePurpleWrap} sx={{ overflow: 'visible !important' }}>
            <Typography component="span" className={classes.heroTitlePurple} sx={{ overflow: 'visible', display: 'inline-block', paddingBottom: '4px' }}>
              servicio
            </Typography>
          </Box>

          {/* Description Paragraph */}
          <Typography className={classes.subtitleMain}>
            App Conecta2 Multiservices es la solución ideal para gestionar tus reservas de forma rápida y sencilla. Con solo un clic, puedes solicitar presupuestos o reservar cualquier servicio en línea. Accede a una amplia variedad de servicios en todo el país, conectándote con las mejores opciones disponibles y gestionando todo desde un solo lugar.
          </Typography>

          {/* CTA Pill Button */}
          <Button
            className={classes.heroCtaBtn}
            onClick={handleCtaClick}
          >
            <span>{role === 'driver' || (calcEst && !showEst && !optionsRequired && (role === 'admin' || role === 'fleetadmin')) ? t('info') : 'PIDE YA'}</span>
            <span className={classes.heroArrowCircle}>
              <ArrowForwardIcon sx={{ fontSize: '18px' }} />
            </span>
          </Button>
        </Grid>
      </Grid>

      {/* Download App QR Badge at bottom right */}
      <Box 
        className={classes.qrBadgeContainer}
        onClick={() => {
          const downloadSection = document.getElementById('download');
          if (downloadSection) {
            downloadSection.scrollIntoView({ behavior: 'smooth' });
          } else {
            navigate('/download');
          }
        }}
      >
        <Typography className={classes.qrBadgeText} style={{fontFamily: FONT_FAMILY}}>
          Descarga la app
        </Typography>
        <QrCode2Icon className={classes.qrBadgeIcon} />
      </Box>
    </Box>
  );
};

export default Hero;